import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Cómo recibo el acceso a Renovación Sin Obras una vez que pago?',
  answer: 'Apenas se acredita el pago, recibís el acceso inmediato por mail. Entrás desde tu celular o computadora y podés empezar el mismo día. No hay envíos físicos ni demoras.'
}, {
  question: '¿Es realmente un pago único o después me cobran algo más?',
  answer: 'Es un solo pago de $19.990 ARS. No hay cuotas, membresías ni cargos escondidos. Pagás una vez y es tuyo para siempre.'
}, {
  question: '¿De verdad puedo lograr ese cambio sin romper nada?',
  answer: 'Sí. El sistema está pensado para cubrir, actualizar y modernizar lo que ya tenés. No es "disimular", es transformar visualmente sin escombros ni obra tradicional.'
}, {
  question: '¿Y si no tengo experiencia haciendo algo así?',
  answer: 'No necesitás experiencia previa. Está diseñado para personas comunes que quieren un resultado moderno sin contratar obreros ni usar herramientas profesionales.'
}, {
  question: '¿Y si lo hago y queda como algo improvisado o barato?',
  answer: 'Justamente uno de los focos es que el resultado se vea prolijo y actual. No se trata de pegar cosas al azar, sino de aplicar criterios estéticos claros para que el cambio se note bien.'
}, {
  question: '¿Cuánto tiempo real necesito para ver un cambio?',
  answer: 'Podés trabajar por ambiente. En una jornada o fin de semana ya ves un antes y después visible, sin alterar tu rutina ni convivir con meses de obra.'
}, {
  question: '¿Qué pasa si lo compro y siento que no es para mí?',
  answer: 'Tenés 30 días de garantía. Si al revisarlo considerás que no se adapta a tu situación, pedís la devolución y recuperás tu dinero. Sin vueltas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 md:py-12 px-4 md:px-6 lg:px-8 bg-white" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <div className="text-center mb-5" data-id="element-35">
          <h2 className="text-xl md:text-2xl font-black text-black tracking-tight" data-id="element-36">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-1.5" data-id="element-37">
          {faqs.map((faq, index) => <div key={index} className="bg-lightgray rounded-lg overflow-hidden" data-id="element-38">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-3 text-left focus:outline-none" data-id="element-39">
                <span className="font-black text-black text-xs md:text-sm pr-3 leading-snug" data-id="element-40">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-4 h-4 text-orange transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-41" />
              </button>

              <AnimatePresence data-id="element-42">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-43">
                    <div className="px-3 pb-3 text-black/80 font-medium text-xs leading-relaxed" data-id="element-44">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}